import React from "react";

const ServicePageLayout = ({
  title,
  imageTitle,
  subtitle,
  heroImage,
  sectionTitle,
  description,
  benefitsTitle,
  benefits,
  secondaryImage,
  servicesTitle,
  services,
  heroBanner
}) => {
  return (
<div className="max-w-7xl mx-auto pt-60 md:pt-36 pb-6 px-4 sm:px-6 md:px-12 space-y-16">
      {/* Hero Section */}
      <div className="relative w-full aspect-[4/3] sm:aspect-[16/9] md:aspect-[16/7] lg:aspect-[16/5] overflow-hidden rounded-xl">
        <img
          src={heroImage}
          alt={`${title} Background`}
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/30 flex flex-col items-center justify-center text-center text-white px-4 sm:px-8">
          <h1 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold leading-snug">
            {imageTitle.map((line, index) => (
              <React.Fragment key={index}>
                {line}
                <br />
              </React.Fragment>
            ))}
          </h1>
        </div>
      </div>


      {/* Title Section */}
      <div className="text-center space-y-2">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold">
          {title}
        </h2>
        {subtitle && (
          <p className="text-base sm:text-lg text-black-600">{subtitle}</p>
        )}
      </div>

      {/* Info Section */}
      <div className="flex flex-col md:flex-row md:items-start md:gap-10">
        <div className="md:w-2/3 space-y-4">
          <h3 className="text-4xl font-bold text-center">{sectionTitle}</h3>
          {description.map((para, i) => (
            <p key={i} className="text-black-700 text-xl font-semibold">
              {para}
            </p>
          ))}

          {benefitsTitle && (
            <p className="text-black font-bold">{benefitsTitle}</p>
          )}
          {benefits && (
            <ul className="list-disc list-inside font-bold text-black-700 space-y-1">
              {benefits.map((b, i) => (
                <li key={i}>{b}</li>
              ))}
            </ul>
          )}
        </div>

        {secondaryImage && (
          <div className="md:w-1/2 mt-8 md:mt-0">
            <img
              src={secondaryImage}
              alt="Supporting Visual"
              className="w-full rounded-xl object-cover"
            />
          </div>
        )}
      </div>

      {/* Services Grid */}
      <div className="space-y-6">
        <h3 className="text-3xl md:text-4xl font-bold text-center">
          {servicesTitle}
        </h3>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-black-100 rounded-xl p-6 shadow-md transition"
            >
              <h4 className="text-xl font-bold mb-2">{service.title}</h4>
              <p className="text-md text-black-700">{service.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ServicePageLayout;
